import styled from 'styled-components';

const Headline = styled.h2`
  font-size: 2rem;
  margin-bottom: 2rem;
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;

  > button:not(:last-child) {
    margin-right: 1.2rem;
  }
`;

const Input = styled.input`
  border: 1px solid #9a9a9a;
  border-radius: 8px;
  width: 100%;
  margin-top: 1rem;

  :first-child {
    margin-top: 1.6rem;
  }
`;

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '400px',
    // O menu do select de proprietário abre para fora do formulário. Com o
    // `overflow: auto` que o react-modal aplica por padrão ele era cortado, e
    // a lista só aparecia rolando o modal. O conteúdo aqui é curto e fixo,
    // então não há o que rolar de qualquer forma.
    overflow: 'visible',
  },
};

export { Headline, Input, ButtonsContainer, modalStyles };
